import React, { useState } from "react";
import BaseModal from "react-bootstrap/Modal";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import { useDispatch } from "redux-react-hook";
import { Subscription, SubscriptionStatus } from "../../types/subscriptionTypes";

type Props = {
  show: boolean;
  onHide: () => void;
  subscriptionId: Subscription;
};

const ExpireModal: React.FC<Props> = ({
  show,
  onHide,
  subscriptionId,
}) => {
  const dispatch = useDispatch();
  const [expireMessage, setExpireMessage] = useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  const handleClick = () => {
    onHide();
    setIsLoading(true);
    dispatch({
      type: "UPDATE_SUBSCRIPTION",
      payload: {
        id: subscriptionId.id,
        data: {
          status: SubscriptionStatus.EXPIRED,
          payment_decline_reason: expireMessage,
        },
      },
    });
    setIsLoading(false);
  };

  return (
    <BaseModal show={show} onHide={onHide} size="lg" centered>
      <BaseModal.Header className="px-4">
        <BaseModal.Title>Expire Subscription #{subscriptionId.id}</BaseModal.Title>
        <button type="button" className="close" onClick={onHide}>
          ×
        </button>
      </BaseModal.Header>
      <BaseModal.Body className="p-0">
        <Container className="pt-5 pb-4 px-4">
          <Form onSubmit={handleClick}>
            <Row>
              <Col>
                <Form.Group controlId="return-reason">
                  <Form.Label as="h6" className="small font-weight-bold font-size-sm asterisk">
                    Reason For Expiring
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    required
                    style={{ resize: "none" }}
                    placeholder="Insert here"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setExpireMessage(e.target.value)}
                  />
                </Form.Group>
                <div className="d-flex align-items-center justify-content-end mt-5">
                  <Button
                    variant="link"
                    className="mr-2 font-weight-bold"
                    style={{ width: 120, height: 40 }}
                    disabled={isLoading}
                    onClick={onHide}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="font-weight-bold w-[120px] h-[40px] "
                    disabled={!expireMessage || isLoading}
                    onClick={handleClick}
                  >
                    {isLoading ? <Spinner as="span" animation="border" size="sm" role="status" /> : "Confirm"}
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Container>
      </BaseModal.Body>
    </BaseModal>
  );
};

export default ExpireModal;
